import React, { useEffect, useState } from 'react'
import { Box, Button, Grid,} from '@mui/material'
import { Item } from '../../../../common/snippets'
import moment from 'moment'
import Datepicker from '../../../../common/datePicker'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { focusElemnt, isEmpty, jsPdfDidParseCellCallback, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import DropDownOA from '../../../../common/dropDownOA'
import { columnDefsFilter, columnDefsFour, columnDefsThree, columnDefsTwo, detailedTableStyles, filterDetailed, filterSummary, summaryTableStyles } from './constants'
import VoucherRptDetailedTable from './VoucherRptDetailedTable'
import VoucherRptSummaryTable from './VoucherRptSummaryTable'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { connect } from 'react-redux'
import { updateAlertError, updateLoader } from '../../../../../store/common/common_action'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../../common/font/font/Roboto-bold';
import { callAddFontRobotoMedium } from '../../../../common/font/font/Roboto-Medium-normal';
import { PostRequest } from '../../../../common/api'
import { urls } from '../../../../common/constants'
import { getPartyVoucherReportData } from '../../../../../store/Acounting/acounting_action'

const VoucherReports = (props) => {
  const {
    data: { common }, updateAlertError, getPartyVoucherReportData
  } = props
  const { loginData } = common
  const [tableData, setTableData] = useState([])
  const reportViewList = [{ id: 0, name: 'Detailed' }, { id: 1, name: 'Summary' }]
  const transactionType = [{ id: 0, name: 'All' }, { id: 1, name: 'Booking' }, { id: 2, name: 'Delivery' }]
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [sourceCityList, setSourceCityList] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [resPartyCity, setResPartyCity] = useState([])
  const [updatedRes, setUpdatedRes] = useState([])
  const [selTransType, setSelTransType] = useState(transactionType[0])
  const [isPdfLoaded, setIsPdfLoaded] = useState(false);
  const [setReportType, setSelReportType] = useState(reportViewList[0])
  const [showReport,setShowReport]=useState(false)
  const filterData = {
    partyCity: selSourceCity?.CityName,
    partyName: selSourceBranch?.Party,
    voucherType: selTransType?.name,
    reportType: setReportType?.name
  }
  useEffect(() => {
    const partyCity = resPartyCity.flatMap((party) => {
      const cityIds = party.CityID.split("~");
      const cityNames = party.PartyCitiesNames.split("~");
      return cityIds.map((id, index) => ({
        PartyID: party.PartyID,
        Party: party.Party,
        CityID: id,
        CityName: cityNames[index] || "",
      }));
    });
    setUpdatedRes(partyCity)
  }, [resPartyCity])
  useEffect(() => {
    const cities = updatedRes?.map(record => ({ CityID: record.CityID, CityName: record.CityName }));
    const cityList = removeDuplicatesFromArray(cities, 'CityID')
    const partyList = removeDuplicatesFromArray(updatedRes, 'PartyID')
    setSourceCityList([...cityList])
    setSourceBranchList([...partyList])
  }, [updatedRes])
  useEffect(() => {
    const loginCity = sourceCityList?.filter((val) => val?.CityID === loginData?.intBranchCityID)
    if (loginCity?.length > 0) {
      setSelSourceCity(loginCity[0])
    } else {
      setSelSourceCity(sourceCityList[0])
    }
  }, [sourceCityList])
  useEffect(() => {
    setSelSourceBranch(sourceBranchList[0])
  }, [sourceBranchList])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intPartyID: 0,
        intCompanyID: loginData.intCompanyID,
        strPartyName: "",
        strContactPerson: "",
        intCityID: 0,
        intIsCreditParty: -1,
        intIsActive: -1,
        intIsDeleted: 0
      }
      PostRequest(urls.getPartyList, obj).then((res) => {
        if (res.status === 'Success') {
          setResPartyCity(res?.Data)
        }
      })
    }
  }, [loginData])
  const generatepdf = (isSave) => {
    try {
      setIsPdfLoaded(false);
      jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
      jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

      const doc = setReportType?.id === 0 ?
        new jsPDF({
          orientation: 'l',
          format: [1754, 1240],
          unit: 'px',
          compress: true
        })
        :
        new jsPDF({
          orientation: 'p',
          format: [1240, 1754],
          unit: 'px',
          compress: true
        })
      const header1 = columnDefsFilter.map((item) => ({
        header: item.headerName, dataKey: item.field, xlCol: item.xlCol
      }))
      const hraderTableData = [{ ...filterData }]
      // const hraderTableData = {

      // }
      const pdfColumnDefs = setReportType?.id === 0 ? columnDefsFour.map((item) => ({
        header: item.headerName, dataKey: item.field, xlCol: item.xlCol
      })) :
        columnDefsThree.map((item) => ({
          header: item.headerName, dataKey: item.field, xlCol: item.xlCol
        }))
      doc.setProperties({
        title: `VoucherReport.pdf`,
        subject: 'Voucher Report',
        author: 'Maven Tech Labs Pvt. Ltd.',
        keywords: 'maven tech, Cargo system, Generate Voucher',
        creator: 'MTLPL',
      })

      var totalPagesExp = '{total_pages_count_string}'
      const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {

        const doc = data.doc
        // Footer
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

        var str = 'Page : ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }
        doc.setFontSize(16)
        doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, "right")
        doc.setFont('Roboto', 'bold')
        doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
        doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
      }
      autoTable(doc, {
        margin: { left: 30, right: 30, bottom: 5 },
        startY: 124,
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        theme: 'grid',
        columns: header1,
        body: hraderTableData,
        headStyles: {
          fillColor: [191, 225, 255],
          textColor: [0, 0, 0],
          minCellHeight: 36,
          valign: 'middle',
          cellPadding: 12,
          fontSize: 16,
          lineWidth: 0.6,
          font: 'Roboto',
          fontStyle: "normal"
        },
        columnStyles: setReportType?.id === 0 ? filterDetailed : filterSummary,
        didParseCell: function (data) {
          if (data.row.index === 0) {
            data.cell.styles.textColor = '#000000';
          }
        },
        didDrawPage: function (data) {
          jsPdfHeaderFooter(data, loginData, totalPagesExp);
        }
      })
      autoTable(doc, {
        margin: { top: 120, left: 30, right: 30, bottom: 60 },
        startY: doc.lastAutoTable.finalY + 24,
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        theme: 'grid',
        columns: pdfColumnDefs,
        showHead: 'everyPage',
        body: tableData,
        tableLineWidth: 0.6,
        rowPageBreak: 'avoid',
        styles: {
          lineWidth: [0, 0.6, 0, 0.6]
        },
        columnStyles: setReportType?.id === 0 ? detailedTableStyles : summaryTableStyles,
        headStyles: {
          fillColor: [191, 225, 255],
          textColor: [0, 0, 0],
          fontSize: 16,
          minCellHeight: 36,
          cellPadding: 12,
          valign: 'top',
          font: 'Roboto',
          fontStyle: "normal"
        },

        didParseCell: function (data) {
          // var rows = data.table.body;
          jsPdfDidParseCellCallback(data, pdfColumnDefs, [])
        },
        willDrawCell: (data) => {
          if (data.row.raw.isSubHeading) {
              doc.setFillColor(191, 225, 255);
              doc.setTextColor(0, 0, 0);
              doc.setFontSize(16).setFont("Roboto", 'normal')
              data.cell.styles.valign = 'middle';
          }
          else if (data.row.raw.isSubHeadingRow) {
              doc.setFillColor(241, 249, 255);
              doc.setTextColor(0, 0, 0);
              doc.setFontSize(16).setFont("Roboto", 'normal')
          } else if (data.row.raw.isTotalRow) {
              doc.setFillColor(238, 238, 238);
              doc.setTextColor(0, 0, 0);
              doc.setFontSize(16).setFont("Roboto", 'normal')
          } else if (data.row.raw.isPrintHeading) {
              doc.setFillColor(191, 225, 255);
              doc.setTextColor(0, 0, 0);
              doc.setFontSize(16).setFont("Roboto", 'normal')
          }
      },
        didDrawPage: function (data) {
          doc.setTextColor(40)
          doc.addImage('/images/logo-66.png', 'JPEG', 30, 40, 40, 40)
          doc.setFontSize(26).setFont("Roboto", 'bold')
          doc.setTextColor(16, 79, 162)
          doc.text('Cargo System | Party Voucher', 30 + 60, 70)
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(22).setFont("Roboto", 'normal')
          doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 70, "right")
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(20)
          doc.setFont('Roboto', 'bold')
          doc.text(`Party Voucher : Voucher Reports`, 30, 110)
          doc.setFontSize(20)
          doc.setFont('Roboto', 'bold')
          doc.text(`Voucher Date: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, doc.internal.pageSize.width - data.settings.margin.left, 110, 'right')
          //   jsPdfHeaderFooter(data, loginData, totalPagesExp);
        }
      })
      doc.setFont('Roboto')
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setIsPdfLoaded(true);
      // if (isSave) {
      // doc.save(`Cargo Unloading Report ${new Date().getTime()}.pdf`)
      setTimeout(() => {
        document.getElementById('VoucherReport').data = doc.output('datauristring', 'VoucherReport.pdf')
        focusElemnt('cuBackBtn')
      }, 1000)
      // } 
    } catch (err) {
      console.log(err)
      setIsPdfLoaded(false)
    }
  }
  const groupData = (data) => {
    let voucherData = []
    let totalRow = {
      GSTAmt: 0,
      TotalNetAmt: 0,
      TotalPaidAmt: 0,
      Discount: 0,
      NetAmtToRcv: 0,
    }
    voucherData.push(
      { isSubHeadingRow: true, subHeadingData: [{ caption: 'Party Name:', value: data[0].Party, colSpan: 5, align: 'left' }, { caption: 'Party City :', value: data[0].CityName, colSpan: 5, align: 'center' }, { caption: 'Voucher Type:', value: data[0].TransactionType, colSpan: 5, align: 'right' }] }
    )
    // voucherData.push(
    //     { isSubHeading: true, ...columnDefsForGrouping }
    // )
    data.forEach((val, index) => {
      totalRow = {
        GSTAmt: (Number(totalRow.GSTAmt) + Number(val.GSTAmt)).toFixed(2),
        TotalNetAmt: (Number(totalRow.TotalNetAmt) + Number(val.TotalNetAmt)).toFixed(2),
        TotalPaidAmt: (Number(totalRow.TotalPaidAmt) + Number(val.TotalPaidAmt)).toFixed(2),
        Discount: (Number(totalRow.Discount) + Number(val.Discount)).toFixed(2),
        NetAmtToRcv: (Number(totalRow.NetAmtToRcv) + Number(val.NetAmtToRcv)).toFixed(2),
      }
      voucherData.push({ ...val, SN: index + 1, isDataRow: true,VoucherDate:moment(val.VoucherDate).format('DD-MMM-YY hh:mm A')})
    })
    voucherData.push({ isTotalRow: true, ...totalRow, totalCaption: `TOTAL: ${data[0].Party}(${data[0].CityName}) Voucher Type: ${data[0].TransactionType}`, colSpan: 11 })
    return voucherData
  }
  const summaryGroupData = (data) => {
    let voucherData = []
    let totalRow = {
      TotalNetAmt: 0,
      TotalPaidAmt: 0,
      Discount: 0,
      NetAmtToRcv: 0,
    }
    data.forEach((val, index) => {
      totalRow = {
        TotalNetAmt: (Number(totalRow.TotalNetAmt) + Number(val.TotalNetAmt)).toFixed(2),
        TotalPaidAmt: (Number(totalRow.TotalPaidAmt) + Number(val.TotalPaidAmt)).toFixed(2),
        Discount: (Number(totalRow.Discount) + Number(val.Discount)).toFixed(2),
        NetAmtToRcv: (Number(totalRow.NetAmtToRcv) + Number(val.NetAmtToRcv)).toFixed(2),
      }
      voucherData.push({ ...val, SN: index + 1, isDataRow: true,VoucherDate:moment(val.VoucherDate).format('DD-MMM-YY hh:mm A') })
    })
    voucherData.push({ isTotalRow: true, ...totalRow, totalCaption: 'TOTAL', colSpan: 6 })
    return voucherData
  }
  const handleGenerate = () => {
    setShowReport(true)
    if(Math.abs(toDate.diff(fromDate, 'days'))>31){
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    }else{
    const body = {
      CompanyID: loginData.intCompanyID,
      PartyID: selSourceBranch?.PartyID,
      FromDate: moment(fromDate).format('YYYY-MM-DD'),
      Todate: moment(toDate).format('YYYY-MM-DD'),
      TransType: selTransType?.id === 0 ? 'All' : selTransType?.id === 1 ? 'Booking' : 'Delivery',
    }
    getPartyVoucherReportData(body).then((res) => {
      updateLoader(false)
      if (res.status === 'Success') {
        if (setReportType?.id === 0) {
          let groupedData = res?.Data?.Table1?.reduce((result, item) => {
            // let groupedData = res?.Data?.Table.reduce((result, item) => {
            const key = `${item.CityName} ${item.Party} ${item.TransactionType}`
            if (!result[key]) {
              result[key] = []
            } result[key].push(item)
            return result
          }, {})
          let newData = []
          Object.keys(groupedData).forEach((key) => {
            const updateData = groupData(groupedData[key]);
            newData = [...newData, ...updateData]
          })
          let totalRow = {
            GSTAmt: 0,
            TotalNetAmt: 0,
            TotalPaidAmt: 0,
            Discount: 0,
            NetAmtToRcv: 0,
          }
          newData.forEach((val) => {
            if (val.isTotalRow) {
              totalRow = {
                GSTAmt: (Number(totalRow.GSTAmt) + Number(val.GSTAmt)).toFixed(2),
                TotalNetAmt: (Number(totalRow.TotalNetAmt) + Number(val.TotalNetAmt)).toFixed(2),
                TotalPaidAmt: (Number(totalRow.TotalPaidAmt) + Number(val.TotalPaidAmt)).toFixed(2),
                Discount: (Number(totalRow.Discount) + Number(val.Discount)).toFixed(2),
                NetAmtToRcv: (Number(totalRow.NetAmtToRcv) + Number(val.NetAmtToRcv)).toFixed(2),
              }
            }
          })
          newData.push({ isTotalRow: true, ...totalRow, totalCaption: 'TOTAL: All Voucher Type: ALL', colSpan: 11 })
          setTableData(newData || [])
        } else {
          let summaryData = summaryGroupData(res?.Data?.Table)
          setTableData(summaryData || [])
        }
        // const data = bodyData?.map((val, index) => ({ ...val}));
        // setFilteredData(newData || [])
        // setTotalNoOfRows(2)
        // setShowTable(true)
      } else {
        updateAlertError({ show: true, msg: res?.Message, nextId: 'loadbtn' })
        // setShowTable(false)
        setTableData([])
      }
    })
    }
  }
  const selectedCity = (val) => {
    setSelSourceCity(val)
    let result = updatedRes?.filter((obj) => obj.CityID === val.CityID || val?.CityID === 0 || obj.PartyID === 0)
    setSourceBranchList([...result])
  }
  return (
    <>
      <Grid container sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
        <Grid item md={1.5}>
          <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Voucher Date`}
              // name={'from_date'}
              id={'fromDate'}
              // value={fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('toDate')
                setShowReport(false)
              }}
              width="100%"
            // startDate={'2022-01-01'}
            // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
            // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
            />
          </Item>
        </Grid>
        <Grid item md={1.5}>
          <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Voucher Date'}
              // name={'to_date'}
              id={'toDate'}
              // value={toDate}
              dateChange={(date) => {
                setToDate(date)
                setShowReport(false)
                // focusElemnt(disableBtn ? id.creditTransSplitButton : id.stateId)
              }}
              width="100%"
            // startDate={'2022-01-01'}
            // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
            // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
            />
          </Item>
        </Grid>
        <Grid item md={1.5}>
          <Item sx={{ ...sx.itemsx }} className="input--container">
            <DropDownOA
              id={'partyCity'}
              label={'Party City'}
              data={sourceCityList}
              defaultvalue={selSourceCity?.CityName}
              idKey={`CityID`}
              dataKey={`CityName`}
              onSelect={(val) => {
                selectedCity(val)
                setShowReport(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Party City`}
              width="100%"
            // nextId={id.srcBranch}
            // prevId={id.stateId}
            // resetFlag={resetFlag || resetCity}
            // disabled={disableBtn}
            />
          </Item>
        </Grid>
        <Grid item md={1.5}>
          <Item sx={{ ...sx.itemsx }} className="input--container">
            <DropDownOA
              id={'partyName'}
              label={'Party Name'}
              data={sourceBranchList}
              defaultvalue={selSourceBranch?.Party || ''}
              idKey={`PartyID`}
              dataKey={`Party`}
              onSelect={(val) => {
                // setIsExpanded(false)
                setShowReport(false)
                setSelSourceBranch(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Party Name`}
              width="100%"
            // nextId={id.creditUsageSplitButton}
            // prevId={id.srcCity}
            // resetFlag={resetFlag || resetCity}
            // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
        </Grid>
        <Grid item md={1.5}>
          <Item sx={{ ...sx.itemsx }} className="input--container">
            <DropDownOA
              id={'gv-transactionType'}
              label={'Voucher Type'}
              searchPlaceholder={`Search By Voucher Type`}
              data={transactionType}
              defaultvalue={selTransType?.name}
              // value={filters?.transactionType?.name}
              onSelect={(val) => { setSelTransType(val);setShowReport(false) }}
              // onReset={() => {
              // }}
              idKey={`id`}
              dataKey={`name`}
              nextId={``}
              prevId={``}
              width="100%"
            />
          </Item>
        </Grid>
        <Grid item md={1.5}>
          <Item sx={{ ...sx.itemsx }} className="input--container">
            <DropDownOA
              id={'gv-partyGSTN'}
              label={'Report Type'}
              searchPlaceholder={`Search By Report Type`}
              data={reportViewList || []}
              defaultvalue={setReportType?.name}
              value={setReportType?.name}
              onSelect={(val) => { setSelReportType(val);setShowReport(false) }}
              // onReset={() => {
              // }}
              idKey={`id`}
              dataKey={`name`}
              nextId={``}
              prevId={``}
              width="100%"
            />
          </Item>
        </Grid>
        <Grid item md={1}>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, 'cityPairSave_btn', 'destination_City', () => { })}
              id={'load_Btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              onClick={handleGenerate}
            >
              Generate
            </Button>
          </Item>
        </Grid>
        <Grid item md={0.8}>
          <Item sx={{ ...sx.itemsx }} className="">
            <Button
              variant="outlined"
              color="secondary"
              id={'filterBtn'}
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onClick={() => {
                generatepdf()
              }}
            >
              Print
            </Button>
          </Item>
        </Grid>
        <Grid item md={0.8}>
          <Item sx={{ ...sx.itemsx }} className="">
            <Button
              variant="outlined"
              color="secondary"
              id={'exportBtn'}
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onClick={() => {
                document.getElementById("test-table-xls-button").click();
              }}
            >
              Excel
            </Button>
            <ReactHtmlTableToExcel
              id="test-table-xls-button"
              className="hidden"
              table="table-to-xls" // Make sure to set the correct table ID
              filename="Voucher Report"
              sheet="tablexls"
              buttonText=""
            />

          </Item>
        </Grid>
      </Grid>

      {isPdfLoaded ? <><Box style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', alignItems: 'center', padding: '10px 25px 5px 25px' }}>
        <Button
          id='cuBackBtn'
          style={{
            borderRadius: '5px',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '15px',
            color: '#fe5200',
            background: 'white',
            marginLeft: '620px',
            border: '2px solid #fe5200',
          }}
          onClick={() => setIsPdfLoaded(false)}
        >
          Back
        </Button>
      </Box>
        <Box sx={{ marginLeft: 2, marginRight: 1.5, height: 430, paddingTop: '10px' }} >
          <object
            id="VoucherReport"
            type="application/pdf"
            width={"100%"}
            height="440vh"
            title={`MTLPL - Voucher Report-${setReportType?.name}`}
            aria-label="MTLPL - CARGO - Voucher Report"
          >
          </object>
        </Box></> :
        <>
          {showReport?setReportType?.id === 0?<VoucherRptDetailedTable loginData={loginData} filters={setReportType} tableData={tableData} setTableData={setTableData} filterData={filterData}/> : <VoucherRptSummaryTable loginData={loginData} filters={setReportType} tableData={tableData} setTableData={setTableData} filterData={filterData}/>:null}
        </>
        }
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getPartyVoucherReportData }
export default connect(mapStateToProps, mapDispatchToProps)(VoucherReports)
